import { SMSStock } from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';
import { infuse } from '../ioc-config';
import { StockType } from '../models/vehicle.model';

export const isEstimatedArrivalDateValid = (date: string | undefined) => {
  const { showEstimatedArrivalDate } = infuse('config');
  const isRelevant = date && new Date(date).getTime() > Date.now();

  return !!(showEstimatedArrivalDate && isRelevant);
};

export const isInStock = (stockType: string | undefined) => {
  return stockType !== StockType.COMING_SOON;
};

export const getStockTrackingValue = (stock: SMSStock | undefined) => {
  return isInStock(stock?.stockType)
    ? 'in_stock'
    : isEstimatedArrivalDateValid(stock?.estimatedArrivalDate)
    ? 'estimated_arrival_in_future'
    : 'coming_soon';
};
